<template>
<div class="audioList">
    <div class="filters">
        <div class="add">
            <el-button v-if="permission.btnList.indexOf('A020601')==-1" type="primary" @click="handleAdd">发布音频</el-button>
        </div>
        <div class="search">
            <el-select v-model="param.status" placeholder="全部状态" class="condition" clearable>
                <el-option v-for="item in typeList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
            </el-select>
            <el-input v-model="param.subject" placeholder="请输入音频名称" class="condition" clearable></el-input>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="subject" label="音频名称" width="454px" class-name="title">
                <template slot-scope="scope">
                    <div class="imageText">
                        <img v-lazy="scope.row.coverurl" :alt="scope.row.subject" preview="audioList">
                        <div class="imageText-summary">
                            <div class="textBox">
                                <div class="text">
                                    <span class="recommon" v-if="scope.row.isinnerrecomm === 1">推荐</span>{{ scope.row.subject }}
                                </div>
                            </div>
                            <div class="price">
                                <span v-if="scope.row.feetype === 1">免费</span>
                                <span v-else>￥{{scope.row.saleprice}}</span>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="viewcount" label="点播量" class-name="center"></el-table-column>
            <el-table-column prop="status" label="上架状态" class-name="center">
                <template slot-scope="scope">
                    <span :class="status(scope.row.status)">.{{scope.row.status | status}}</span>
                    <el-tooltip :content="scope.row.memo" placement="top" v-if="scope.row.status == 11">
                        <div>
                            <i class="icon icon_warning"></i>
                        </div>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="datetime" label="发布时间" class-name="center" width="200"></el-table-column>
            <el-table-column label="操作" width="250" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                        <span v-if="[1, 100].indexOf(scope.row.status)<=-1 && permission.btnList.indexOf('A020602')==-1">
                            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                            <span class="separator">|</span>
                        </span>
                        <span v-if="scope.row.status == 31 && permission.btnList.indexOf('A020603')==-1">
                            <el-button @click="handleUpperShelf(scope.row)" type="text" size="small">上架</el-button>
                            <span class="separator">|</span>
                        </span>
                        <span v-if="scope.row.status == 30 && permission.btnList.indexOf('A020604')==-1">
                            <el-button @click="handleLowerShelf(scope.row)" type="text" size="small">下架</el-button>
                            <span class="separator">|</span>
                        </span>
                        <span v-if="scope.row.status !== 31">
                            <!-- <el-popover trigger="click" placement="top" width="320" v-model="scope.row.visible">
                                <div class="audioList-pr-code-upload padding-20">
                                    <img :src="scope.row.qrShare" :alt="scope.row.subject">
                                    <div class="pr-code-text cursor" @click="download(scope.row.qrShare, scope.row.subject)">下载二维码</div>
                                    <div class="btn-operate">
                                        <el-input v-model="scope.row.share" class="condition"></el-input>
                                        <el-button  type="primary" size="mini" v-clipboard:copy="scope.row.share" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                                    </div>
                                </div>
                                <el-button slot="reference" type="text" size="small">分享</el-button>
                            </el-popover>
                            <i class="separator">|</i> -->
                            <Share :row='scope.row'></Share>
                            <!-- <i class="separator">|</i> -->
                        </span>
                        <span v-if="permission.btnList.indexOf('A020609')==-1">
                            <el-button @click="handleDel(scope.row)" type="text" size="small">删除</el-button>
                        </span>
                        <!-- <span v-if="permission.btnList.indexOf('A020607')==-1 && ((scope.row.isinnerrecomm === 2 || scope.row.isinnerrecomm === 0) && scope.row.status === 30)">
                            <span class="separator">|</span>
                            <el-button @click="_joinRecommend(scope.row.innerid)" type="text" size="small">加入推荐</el-button>
                        </span>
                        <span v-if="permission.btnList.indexOf('A020608')==-1 && (scope.row.isinnerrecomm === 1 && scope.row.status === 30)">
                            <span class="separator">|</span>
                            <el-button @click="_cancelRecommend(scope.row.innerid)" type="text" size="small">取消推荐</el-button>
                        </span> -->
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" @getList="_getList" ref="page"></page>
    </div>
</div>
</template>

<script>
import {findAllAudio, updateAudioByStatus, joinRecommend} from 'api/api'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {videoMgtCode} from 'api/enumCode'
import Share from '@/base/share/share'
import {promiseUrlToQRCode} from 'common/js/tools'
import {videoMsg} from 'api/message'
export default {
    name: 'audioList',
    data() {
        return {
            logo: require('@/common/images/index/logo.png'),
            typeList: [
                {code: '', name: '全部状态'},
                {code: '10', name: '待上架'},
                {code: '30', name: '已上架'},
                {code: '31', name: '已下架'}
            ],
            total: 0,
            tableData: [],
            power: []
        }
    },
    props: ['param'],
    mounted() {
        this.power = this.permission.btnObj.A0206 ? this.permission.btnObj.A0206 : []
        this._getList()
    },
    methods: {
        handleQuery() {
            this.setParams(this._.cloneDeep(this.param))
            this.$refs.page.handleSizeChange(1)
        },
        handleAdd() {
            if (this.shop.authstatus === 0) {
                this.$confirm('该功能需要在开通企业版或者单独工具基础上方可使用，建议尽快购买，购买后可继续使用该功能', '提示', {
                    confirmButtonText: '去购买',
                    cancelButtonText: '取消'
                }).then(() => {
                    // 去购买
                    this.$router.push({name: 'OrderService'})
                }).catch(() => {
                    // 取消
                })
            } else {
                this.$router.push({name: 'AudioEdit'})
            }
        },
        handleEdit(row) {
            this.$router.push({name: 'AudioEdit', query: {id: row.innerid}})
        },
        handleDel(row) {
            let status = 100
            this.$confirm(videoMsg.del.msg, videoMsg.del.title, {
                confirmButtonText: videoMsg.del.confirmText,
                cancelButtonText: videoMsg.del.cancelText
            }).then(() => {
                this._editStatus(row.innerid, status, videoMsg.del.successMsg)
            }).catch(() => {})
        },
        handleUpperShelf(row) {
            let status = 30
            this._editStatus(row.innerid, status, videoMsg.onShelf.successMsg)
        },
        handleLowerShelf(row) {
            let status = 31
            this.$confirm(videoMsg.offShelf.msg, videoMsg.offShelf.title, {
                confirmButtonText: videoMsg.offShelf.confirmText,
                cancelButtonText: videoMsg.offShelf.cancelText
            }).then(() => {
                this._editStatus(row.innerid, status, videoMsg.offShelf.successMsg)
            }).catch(() => {})
        },
        // 加入推荐
        _joinRecommend(innerid) {
            this.$confirm(videoMsg.addRec.msg, videoMsg.addRec.title, {
                confirmButtonText: videoMsg.addRec.confirmText,
                cancelButtonText: videoMsg.addRec.cancelText
            }).then(() => {
                this.setLoading(true)
                joinRecommend({
                    data: {innerid, isinnerrecomm: '1'},
                    success: data => {
                        this._getList()
                        this.$message({
                            type: 'success',
                            message: videoMsg.addRec.successMsg
                        })
                        this.setLoading(false)
                    },
                    error: data => {
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }
                })
            }).catch(() => {})
        },
        // 取消推荐
        _cancelRecommend(innerid) {
            this.$confirm(videoMsg.removeRec.msg, videoMsg.removeRec.title, {
                confirmButtonText: videoMsg.removeRec.confirmText,
                cancelButtonText: videoMsg.removeRec.cancelText
            }).then(() => {
                this.setLoading(true)
                joinRecommend({
                    data: {innerid, isinnerrecomm: '2'},
                    success: data => {
                        this._getList()
                        this.$message({
                            type: 'success',
                            message: videoMsg.removeRec.successMsg
                        })
                        this.setLoading(false)
                    },
                    error: data => {
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }
                })
            }).catch(() => {})
        },
        _editStatus(innerid, status, tip) {
            this.setLoading(true)
            updateAudioByStatus({
                data: {
                    innerid: innerid,
                    status: status
                },
                success: data => {
                    this.$message.success(tip)
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            // this.param.page = this.page
            findAllAudio({
                // data: this.param,
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.tableData.forEach(obj => {
                        promiseUrlToQRCode(obj.shareurl, obj.coverurl).then(
                            function(data) {
                                obj.qrShare = data
                            },
                            function(reason, data) {
                                console.log('二维码生成失败：', reason)
                            }
                        )
                    })
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {
        status: function (value) {
            for (let i = 0; i < videoMgtCode.status.length; i++) {
                if (value === videoMgtCode.status[i].code) {
                    return videoMgtCode.status[i].name
                }
            }
            return value
        }
    },
    watch: {},
    computed: {
        status () {
            return function(value) {
                for (let i = 0; i < videoMgtCode.status.length; i++) {
                    if (value === videoMgtCode.status[i].code) {
                        return videoMgtCode.status[i].cls
                    }
                }
                return value
            }
        },
        ...mapGetters([
            'page',
            'user',
            'permission',
            'params',
            'shop'
        ])
    },
    components: {
        Page, Share
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.audioList {
    .result-list{
        .tc-complete {
            color: #FFA904 !important
        }
        .share {
            display: inline-block;
        }
        .el-table__row{
            height: 100px;
        }
        .imageText{
            .imageText-summary{
                margin-left: 5px;
                .textBox{
                    width: 345px;
                    height: 40px;
                    line-height: 20px;
                    overflow: hidden;
                    .text{
                        float: right;
                        /* "margin-left"要等于".wrap::before"的宽度 */
                        margin-left: -10px;
                        width: 340px; 
                        word-break: break-all;
                        // font-size: 0.48rem;
                    }
                    &::before {
                        float: left;
                        content: '';
                        width: 10px;
                        height: 100%;
                    }
                    &::after {
                        float: right;
                        content: "...";
                        /* 行高与".wrap"设置的一致即可 */
                        height: 40px;
                        line-height: 20px;
                        /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                        width: 37px;
                        margin-left: -30px;
                        position: relative;
                        left: 96%;
                        bottom: 20px;
                        font-weight: 600;
                        padding-right: 1px;
                        background: #fff;
                        transition: all 0.5s;
                    }
                    .recommon{
                        color: #fff;
                        background: #E6A23C;
                        display: inline-block;
                        width: 36px;
                        height: 16px;
                        line-height: 16px;
                        text-align: center;
                        margin-right: 5px;
                        font-size: 12px;
                    }
                }
                .price{
                    margin-left: 5px;
                    color: #F56C6C;
                }
            }
        }
        .el-table__row:hover{
            .textBox{
                &::after{
                    background: #F5F7FA;
                }
            }
        }
        img{
            min-width: 100px;
            max-width: 100px;
            height: 60px;
        }
        .icon{
            margin-left: 10px;
            width: 14px;
            height: 14px;
        }
    }
    .result-list .imageText .imageText-summary div:nth-child(1){
        margin-bottom: 0;
    }
    .el-table{
        .title{
            .cell{
                padding: 0;
                margin-left: 5px;
            }
        }
        .center{
            .cell{
                text-align: center;
            }
        }
    }
}
.el-popover{
    .audioList-pr-code-upload{
        text-align: center;
        img{
            width: 160px;
            height: 160px;
        }
        .pr-code-text{
            color: $tcolor-blue;
            padding: 20px 0;
        }
        .btn-operate{
            @include flexBox(space-between);
            .el-input,input{
                width: 210px;
                height: 36px;
                line-height: 36px;
            }
            .el-button{
                min-width: 60px;
            }
        }
    }
}
</style>
